var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.3594 88.6364C91.3594 93.4091 95.223 97.2727 99.9957 97.2727C104.768 97.2727 108.632 93.4091 108.632 88.6364C108.632 83.8636 104.768 80 99.9957 80C95.223 80 91.3594 83.8636 91.3594 88.6364ZM104.996 88.6364C104.996 91.4091 102.768 93.6364 99.9957 93.6364C97.2231 93.6364 94.9957 91.4091 94.9957 88.6364C94.9957 85.8637 97.2231 83.6364 99.9957 83.6364C102.768 83.6364 104.996 85.8637 104.996 88.6364Z",
    fill: "#4B2B5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.227 99.5458H93.4091C86 99.5458 80 105.546 80 112.955V114.909C80 116.955 81.6817 118.637 83.7272 118.637H108.182C109.182 118.637 110 117.818 110 116.818C110 115.819 109.182 115 108.182 115H83.7272C83.6818 115 83.6363 114.955 83.6363 114.909V112.955C83.6363 107.546 88 103.182 93.4091 103.182H105.227C111.364 103.182 116.364 108.182 116.364 114.318V114.909C116.364 115.909 117.182 116.728 118.182 116.728C119.182 116.728 120 115.909 120 114.909V114.318C120 106.182 113.364 99.5457 105.227 99.5457L105.227 99.5458Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderIcon);
export default __webpack_public_path__ + "static/media/placeholderIcon.8f799abbb0ffee8469c233eb8f0e0b68.svg";
export { ForwardRef as ReactComponent };